import cntl from "cntl";
import PropTypes from "prop-types";
import { SIZE, BUTTON_VARIANTS, POSITIONS } from "../constants/index";
import Button from "./Button";

const propTypes = {
  icon: PropTypes.object,
  name: PropTypes.string,
  type: PropTypes.string,
  onClick: PropTypes.func,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  iconColor: PropTypes.string,
  className: PropTypes.string,
  buttonRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  size: PropTypes.oneOf([SIZE.sm, SIZE.md, SIZE.lg, SIZE.xl, SIZE["2xl"]]),
  variant: PropTypes.oneOf([
    BUTTON_VARIANTS.default,
    BUTTON_VARIANTS.border,
    BUTTON_VARIANTS.light,
    BUTTON_VARIANTS.border_off,
  ]),
  iconPosition: PropTypes.oneOf([POSITIONS.left, POSITIONS.right]),
};

function ButtonGrey({
  icon,
  name,
  size,
  type,
  label,
  onClick,
  disabled,
  buttonRef,
  iconColor,
  className,
  isLoading,
  iconPosition,
  variant = BUTTON_VARIANTS.default,
}) {
  const borderCn = () => cntl`
    bg-white
    shadow-sm
    enabled:text-grey-700
    disabled:text-grey-300
    enabled:border-grey-300
    disabled:border-grey-200
    enabled:hover:bg-grey-50 enabled:hover:border-grey-300 enabled:hover:text-grey-700
    focus:bg-white focus:border-grey-300 focus:outline focus:outline-4 focus:outline-grey-100
    ${className ? className : undefined}
  `;

  const borderOffCn = () => cntl`
    bg-transparent
    border-transparent
    enabled:text-grey-600
    disabled:text-grey-300
    focus:bg-transparent focus:border-transparent
    enabled:hover:bg-grey-50 enabled:hover:text-grey-700
    ${className ? className : undefined}
  `;

  return (
    <>
      {variant === BUTTON_VARIANTS.border && (
        <Button
          name={name}
          type={type}
          size={size}
          icon={icon}
          label={label}
          onClick={onClick}
          disabled={disabled}
          iconColor={iconColor}
          buttonRef={buttonRef}
          isLoading={isLoading}
          className={borderCn()}
          iconPosition={iconPosition}
        />
      )}
      {variant === BUTTON_VARIANTS.border_off && (
        <Button
          name={name}
          type={type}
          size={size}
          icon={icon}
          label={label}
          onClick={onClick}
          disabled={disabled}
          iconColor={iconColor}
          buttonRef={buttonRef}
          isLoading={isLoading}
          className={borderOffCn()}
          iconPosition={iconPosition}
        />
      )}
    </>
  );
}

ButtonGrey.propTypes = propTypes;
export default ButtonGrey;
